import { Statsig } from 'statsig-react';

/**
 * Tracks the click event of a menu link on Statsig
 * @returns void
 */

const menuLinkClickStatsigTrack = (trackingSlug: string): void => {
  if (trackingSlug) {
    Statsig.logEvent(`menu_link_${trackingSlug}_click`, 1);
  }
};

export default menuLinkClickStatsigTrack;
